import Text from 'components/Text/Text';
import React from 'react';
import breadcrumbs from 'images/breadcrumbs.svg';
import Button from 'components/Button/Button';
import { ICreateModifierValidationError, IItemForGetShortInfo, IServerError } from 'types';
import classNames from 'classnames';
import style from './ModalSentErrorWithInfo.module.scss';

interface IModalSentErrorWithInfo {
	onConsentEvent: () => void;
	isVisible: boolean;
	errorResponseData: IServerError<ICreateModifierValidationError> | null;
	fetchedRestaurants: IItemForGetShortInfo[];
	fetchedModifierGroups: IItemForGetShortInfo[];
}

const ModalSentErrorWithInfo: React.FC<IModalSentErrorWithInfo> = ({
	onConsentEvent,
	isVisible,
	errorResponseData,
	fetchedModifierGroups,
	fetchedRestaurants,
}) => {
	const containerClasses = classNames(style.container, { [style.visible]: isVisible });

	const getAdditionalInfo = () => {
		return errorResponseData?.Metadata?.restaurants.map(
			(el: { restaurantId: string; modifierGroups: string[] }) => {
				const restaurantName =
					fetchedRestaurants.find((fetchedRestaurant) => fetchedRestaurant.id === el.restaurantId)?.name ||
					null;
				const modifierGroupNames: string[] = [];
				for (let i = 0; i < el.modifierGroups.length; i++) {
					for (let j = 0; j < fetchedModifierGroups.length; j++) {
						el.modifierGroups[i] === fetchedModifierGroups[j].id &&
							modifierGroupNames.push(fetchedModifierGroups[j].name);
					}
				}
				return (
					<React.Fragment key={el.restaurantId}>
						<Text
							className={style.nameWrapper}
							translationNameSpace="modals"
							translationKey="restaurantDotHaveThis"
							values={{ restaurantName }}
							components={[
								<Text
									key="1"
									translationNameSpace="modals"
									translationKey="modifierGroupsLabel"
									asFragment={true}
								/>,
							]}
							size="xxl"
							weight="bold"
							align="center"
						/>
						<div className={style.additionalInfoItems}>
							{modifierGroupNames.map((modifierGroupName) => (
								<div className={style.nameWrapper} key={modifierGroupName}>
									<Text
										translationKey={modifierGroupName}
										theme="secondaryLight"
										size="l"
										weight="bold"
										withTooltip={true}
									/>
									,
								</div>
							))}
						</div>
					</React.Fragment>
				);
			},
		);
	};

	return (
		<div className={containerClasses}>
			<div className={style.wrapper}>
				<div className={style.closeIconWrapper} onClick={onConsentEvent}>
					<svg className={style.closeIcon}>
						<use xlinkHref={`${breadcrumbs}#resetIcon`} />
					</svg>
				</div>
				<svg className={style.errorIcon}>
					<use xlinkHref={`${breadcrumbs}#error`} />
				</svg>
				<div className={style.description}>{getAdditionalInfo()}</div>
				<div className={style.btnWrapper}>
					<Button className={style.okBtn} theme="primaryBlue" onClick={onConsentEvent} type="submit">
						<Text translationNameSpace="modals" translationKey="okButton" asFragment={true} />
					</Button>
				</div>
			</div>
		</div>
	);
};

export default React.memo(ModalSentErrorWithInfo);
